import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateDMYYYY } from '../../utils';
import personalizeImg from '../../../assets/image/personalize.png';
import GreenTick from '../../../assets/image/icons/green_tick.svg';
import RedX from '../../../assets/image/icons/red_x.svg';
import GrayDot from '../../../assets/image/icons/gray_dot.svg';
import BlueTag from '../../../assets/image/icons/blue_tag.svg';
import GrayTag from '../../../assets/image/icons/gray_tag.svg';
import TrophyTag from '../../../assets/image/icons/trophy.svg';
//import MegaphoneTag from '../../../assets/image/icons/megaphone.svg';
//import SubscribeALP from '../../../assets/image/subscribe.png';
import { Theme } from '../types/enums';
import Tag, { TagStyle } from '../Tag/Tag';
import { useBreakpoint } from '../Breakpoint/BreakpointProvider';
import { DetailCardProgressPropTypes } from './types/propTypes';
import styles from './index.module.scss';

const DetailCardProgress: FC<DetailCardProgressPropTypes> = (props: DetailCardProgressPropTypes) => {
  const {
    name,
    // totalPoints,
    isNewABO,
    weightIn,
    weightOut,
    //weightOutDiffValues,
    // result,
    purchase,
    //subscribe,
    //coachEnrollmentDate,
    teamStartDate,
    teamEndDate,
    teamDetail,
    isTeamList,
    // coachId,
    // coachName,
    // teamPoint,
    isAllWeightIn,
    isAllWeightOut,
    isAllPurchase,
    //isAllSubscribe,
    isAllWin,
    isAllValidPurchase,
    isIndividualAssessmentAchieved,
    isIndividualAchieved,
    //isCoachEnrollment,
    hideProfileImg = false,
    //points,
    //showFiveProgress = false,
    profileImageUrl,
    handleRedirect,
  } = props;
  //const isCoachEnrolled = (coachEnrollmentDate !== undefined && coachEnrollmentDate !== '') || isCoachEnrollment;
  const isTeamLeader = teamDetail?.teamLeader === name;
  const viewPortType = useBreakpoint();
  const isDesktopView = ['xs', 'sm', 'md'].indexOf(viewPortType) === -1;

  const { t } = useTranslation();
  
  const purchaseStatus = purchase[0]?.orderStatus;

  return (
    <section
      className={styles['card-container']}
      style={{ padding: isTeamList ? '1.5rem' : '10px 16px' }}
      onClick={handleRedirect ? handleRedirect : undefined}
    >
      {/* profile image and details section */}
      {!hideProfileImg && (
        <div className={styles['card-details-main']}>
          <div className={styles['card-details-container']}>
            {/* profile image  */}
            {!isTeamList && (
              <div className={styles['card-details-container-image-container']}>
                <div className={styles['image-wrapper']}><img
                  src={profileImageUrl ? profileImageUrl : personalizeImg}
                  alt="personalize"
                /></div>
                {/* team leader badge boolean*/}
                {isTeamLeader ? <div className={styles['image-badge']}>{t('dashboard.my-team.progress-tracker.label.teamLeader').toUpperCase()}</div> : null}
              </div>
            )}

            {/* profile details */}
            <div className={styles['profile-details-container']}>
              {/* new abo tag boolean*/}
              {isNewABO === 1 ? <div className={styles['new-abo-tag']}>{t('dashboard.my-team.progress-tracker.label.newAbo').toUpperCase()}</div> : null}
              {/* Name */}
              <div className={styles['profile-details-container-header']}>
                <div className={styles['profile-name']}>{name}</div>
                {isTeamList && !isDesktopView && (
                  <Tag
                    text={
                      !weightIn?.weightInDate && !isAllWeightIn && !isAllPurchase
                        ? t('dashboard.my-team.progress-tracker.status.new').toUpperCase()
                        : !weightOut?.weightOutDate && !isAllWeightOut
                          ? t('dashboard.my-team.progress-tracker.status.in-progress').toUpperCase()
                          : t('dashboard.my-team.progress-tracker.status.completed').toUpperCase()
                    }
                    theme={
                      !weightIn?.weightInDate && !isAllWeightIn && !isAllPurchase
                        ? Theme.PURPLE
                        : !weightOut?.weightOutDate && !isAllWeightOut
                          ? Theme.ERROR
                          : Theme.SUCCESS
                    }
                    style={TagStyle.OUTLINE}
                  />
                )}
              </div>

              {isTeamList ? (
                <>
                  <div className={styles['profile-details-container-item']}>
                    <div className={styles['profile-name-label']}>
                      {`${t('dashboard.my-team.progress-tracker.label.period')}: ${teamStartDate
                        ? formatDateDMYYYY(new Date(teamStartDate as string)) +
                        ' - ' +
                        formatDateDMYYYY(new Date(teamEndDate as string))
                        : '-'}`}
                    </div>
                    {/* <div className={styles['profile-name-label']}>Team Leader ID: {coachId ?? '-'}</div>
                    <div className={styles['profile-name-label']}>Team Leader Name: {coachName ?? '-'}</div> */}
                  </div>
                </>
              ) : (
                <>
                  {/* total totalPoints */}
                  {/* {points?.totalPoints ? <div className={styles['profile-name-label']}>Total Points: {points?.totalPoints}</div> : null} */}
                  {/* weighInDate */}
                  <div className={styles['profile-name-label']}>
                    {`${t('dashboard.my-team.progress-tracker.label.preAssessmentDate')}: `}
                    {weightIn?.weightInDate ? formatDateDMYYYY(new Date(weightIn?.weightInDate as string)) : '-'}
                  </div>
                  {/* weightOutDate */}
                  <div className={styles['profile-name-label']}>
                    {`${t('dashboard.my-team.progress-tracker.label.postAssessmentDate')}: `}
                    {weightOut?.weightOutDate ? formatDateDMYYYY(new Date(weightOut?.weightOutDate as string)) : '-'}
                  </div>
                  {/* <div className={styles['profile-name-label']}>
                    {'Team Name : '}
                    {teamDetail?.teamName ? teamDetail?.teamName : '-'}
                  </div> */}
                </>
              )}
            </div>

            {!isTeamList && !isDesktopView && (
              <div className={styles['tag-container-mobile']}>
                <Tag
                  text={
                    !weightIn?.weightInDate && !isAllWeightIn && !isAllPurchase
                      ? t('dashboard.my-team.progress-tracker.status.new').toUpperCase()
                      : !weightOut?.weightOutDate && !isAllWeightOut
                        ? t('dashboard.my-team.progress-tracker.status.in-progress').toUpperCase()
                        : t('dashboard.my-team.progress-tracker.status.completed').toUpperCase()
                  }
                  theme={
                    !weightIn?.weightInDate && !isAllWeightIn && !isAllPurchase
                      ? Theme.PURPLE
                      : !weightOut?.weightOutDate && !isAllWeightOut
                        ? Theme.ERROR
                        : Theme.SUCCESS
                  }
                  style={TagStyle.OUTLINE}
                />
              </div>
            )}
          </div>
          {/* {isCoachEnrolled && !(subscribe?.length > 0) ? (
            <div className={styles['card-details-subscription']}>
              <img
                src={MegaphoneTag}
                alt={MegaphoneTag}
                className={styles['megaphone-tag']}
                width={'30px'}
                height={'30px'}
              />
              <div className={styles['card-details-subscription-tag']}>
                    <Tag
                      text={''}
                      className={styles['description']}
                      theme={Theme.WARNING}
                      style={TagStyle.OUTLINE}
                    >
                        <span>{'Subscribe to the ALP Plan within'}  <span  className={styles['description-black']}>{'75 Days'}</span> {'of your Pre-Assessment date.'}</span>
                    </Tag>
              </div>
            </div>
          ) : null} */}
        </div>
      )}
      {/* profile progress and status  */}
      <div className={styles['profile-progress-container']}>
        {/* top */}{/* status */}
        <div className={styles['tag-container']}>
          {!isTeamList && isDesktopView && (
            <>
              <Tag
                text={
                  !weightIn?.weightInDate && !isAllWeightIn && !isAllPurchase
                    ? t('dashboard.my-team.progress-tracker.status.new').toUpperCase()
                    : !weightOut?.weightOutDate && !isAllWeightOut
                      ? t('dashboard.my-team.progress-tracker.status.in-progress').toUpperCase()
                      : t('dashboard.my-team.progress-tracker.status.completed').toUpperCase()
                }
                theme={
                  !weightIn?.weightInDate && !isAllWeightIn && !isAllPurchase
                    ? Theme.PURPLE
                    : !weightOut?.weightOutDate && !isAllWeightOut
                      ? Theme.ERROR
                      : Theme.SUCCESS
                }
                style={TagStyle.OUTLINE}
              />
            </>
          )}
          {isTeamList && isDesktopView && (
            <Tag
              text={
                !weightIn?.weightInDate && !isAllWeightIn && !isAllPurchase
                  ? t('dashboard.my-team.progress-tracker.status.new').toUpperCase()
                  : !weightOut?.weightOutDate && !isAllWeightOut
                    ? t('dashboard.my-team.progress-tracker.status.in-progress').toUpperCase()
                    : t('dashboard.my-team.progress-tracker.status.completed').toUpperCase()
              }
              theme={
                !weightIn?.weightInDate && !isAllWeightIn && !isAllPurchase
                  ? Theme.PURPLE
                  : !weightOut?.weightOutDate && !isAllWeightOut
                    ? Theme.ERROR
                    : Theme.SUCCESS
              }
              style={TagStyle.OUTLINE}
            />
          )}
        </div>

        {/* middle  */}{/* Progress/Image */}
        <div
          className={`${styles['progress-bar-container']} 
           ${
            //  isCoachEnrolled || showFiveProgress
            //     ? `${styles['progress-bar-container-five']}`
            //     : `${styles['progress-bar-container-four']}`
            `${styles['progress-bar-container-five']}`
            } ${hideProfileImg ? styles['progress-bar-container-center'] : ''}`.trim()}
        >
          <div className={styles['image-container-text']}>{t('dashboard.my-team.progress-tracker.label.productPurchase')}</div>
          <div className={styles['image-container-text']}>{t('dashboard.my-team.progress-tracker.label.preAssessment')}</div>
          <div className={styles['image-container-text']}>{t('dashboard.my-team.progress-tracker.label.postAssessment')}</div>
          <div className={styles['image-container-text']}>{t('dashboard.my-team.progress-tracker.label.assessmentResult')}</div>
          <div className={styles['image-container-text']}>{t('dashboard.my-team.progress-tracker.label.overallResult')}</div>
          {/* {(isCoachEnrolled || showFiveProgress) && (
            <div>
              {subscribe?.length > 0 ?
                ''
                :
                <img
                  src={SubscribeALP}
                  alt={SubscribeALP}
                  className={styles['dot']}
                  width={'20px'}
                  height={'20px'}
                />}
              <div className={styles['image-container-text']}>{'Subscribe ALP'}</div>
            </div>
          )} */}

        </div>

        <div className={`${styles['progress-bar-container-icon']} ${
          // isCoachEnrolled || showFiveProgress
          //   ? `${styles['progress-bar-container-icon-five']}`
          //   :  `${styles['progress-bar-container-icon-four']}`
          `${styles['progress-bar-container-icon-five']}`
          }`}
        >
          {/* purchase */}
          <div className={styles['progress-bar-container-icon-item']}>
            <div className={styles['progress-bar-container-icon-blank']} />
            <div className={styles['progress-bar-container-icon-wrapper']}>
              <img
                src={purchase?.length > 0 || isAllPurchase ? BlueTag : GrayTag}
                alt={purchase?.length > 0 || isAllPurchase ? 'BlueTag' : 'GrayTag'}
                className={styles['tag']}
                width={'20px'}
                height={'20px'}
              />
              <img
                src={
                  purchaseStatus === 1 || isAllValidPurchase
                    ? GreenTick
                    : (purchaseStatus === 0 ) || (!isAllValidPurchase && isAllWeightIn)
                      ? RedX
                      : GrayDot
                }
                alt={
                  purchaseStatus === 1 || isAllValidPurchase
                    ? 'Green Tick'
                    : (purchaseStatus === 0) || (!isAllValidPurchase && isAllWeightIn)
                      ? 'RedX'
                      : 'Grey Dot'
                }
                className={styles['dot']}
                width={'0px'}
                height={'20px'}
              />
            </div>
            <div
              className={
                weightIn?.weightInDate || isAllWeightIn
                  ? styles['progress-bar-container-icon-line-active']
                  : styles['progress-bar-container-icon-line']
              }
            ></div>
          </div>

          {/* weight in */}
          <div className={styles['progress-bar-container-icon-item']}>
            <div
              className={
                weightIn?.weightInDate || isAllWeightIn
                  ? styles['progress-bar-container-icon-line-active']
                  : styles['progress-bar-container-icon-line']
              }
            ></div>
            <div className={styles['progress-bar-container-icon-wrapper']}>
              <img
                src={weightIn?.weightInDate || isAllWeightIn ? BlueTag : GrayTag}
                alt={weightIn?.weightInDate || isAllWeightIn ? 'BlueTag' : 'GrayTag'}
                className={styles['tag']}
                width={'20px'}
                height={'20px'}
              />
              <img
                src={weightIn?.weightInDate || isAllWeightIn ? GreenTick : GrayDot}
                alt={weightIn?.weightInDate || isAllWeightIn ? 'Green Tick' : 'Gray Dot'}
                width={'20px'}
                height={'20px'}
                className={styles['dot']}
              />
            </div>
            <div
              className={
                weightOut?.weightOutDate || isAllWeightOut
                  ? styles['progress-bar-container-icon-line-active']
                  : styles['progress-bar-container-icon-line']
              }
            ></div>
          </div>

          {/* weight out */}
          <div className={styles['progress-bar-container-icon-item']}>
            <div
              className={
                weightOut?.weightOutDate || isAllWeightOut
                  ? styles['progress-bar-container-icon-line-active']
                  : styles['progress-bar-container-icon-line']
              }
            ></div>
            <div className={styles['progress-bar-container-icon-wrapper']}>
              <img
                src={weightOut?.weightOutDate || isAllWeightOut ? BlueTag : GrayTag}
                alt={weightOut?.weightOutDate || isAllWeightOut ? 'BlueTag' : 'GrayTag'}
                className={styles['tag']}
                width={'20px'}
                height={'20px'}
              />
              <img
                src={weightOut?.weightOutDate || isAllWeightOut ? GreenTick : GrayDot}
                alt={weightOut?.weightOutDate || isAllWeightOut ? 'Green Tick' : 'Gray Dot'}
                className={styles['dot']}
                width={'20px'}
                height={'20px'}
              />
            </div>
            <div
              className={`${weightOut?.weightOutDate || isIndividualAssessmentAchieved
                ? styles['progress-bar-container-icon-line-active']
                : styles['progress-bar-container-icon-line']
                }`}
            ></div>
          </div>

          {/* individual assessment result */}
          <div className={styles['progress-bar-container-icon-item']}>
            <div
              className={
                weightOut?.weightOutDate || isIndividualAssessmentAchieved
                  ? styles['progress-bar-container-icon-line-active']
                  : styles['progress-bar-container-icon-line']
              }
            ></div>
            <div className={styles['progress-bar-container-icon-wrapper']}>
              <img
                src={weightOut?.weightOutDate || isAllWeightOut ? BlueTag : GrayTag}
                alt={weightOut?.weightOutDate || isAllWeightOut ? 'BlueTag' : 'GrayTag'}
                className={styles['tag']}
                width={'20px'}
                height={'20px'}
              />
             <img
                src={
                  isIndividualAssessmentAchieved
                    ? GreenTick
                    : isIndividualAssessmentAchieved === null
                      ? GrayDot
                      : RedX
                }
                alt={
                  isIndividualAssessmentAchieved
                    ? GreenTick
                    : isIndividualAssessmentAchieved === null
                      ? GrayDot
                      : RedX
                }
                className={styles['dot']}
                width={'0px'}
                height={'20px'}
              />
            </div>
            <div
              className={`${weightOut?.weightOutDate || isAllWin
                ? styles['progress-bar-container-icon-line-active']
                : styles['progress-bar-container-icon-line']
                }`}
            ></div>
          </div>

          {/* result */}
          <div className={styles['progress-bar-container-icon-item']}>
            <div
              className={`${weightOut?.weightOutDate || isAllWin
                ? styles['progress-bar-container-icon-line-active']
                : styles['progress-bar-container-icon-line']
                }`}
            ></div>
            <div className={styles['progress-bar-container-icon-wrapper']}>
              <img
                src={ weightOut?.weightOutDate || isAllWin ? BlueTag :  GrayTag}
                alt={ weightOut?.weightOutDate || isAllWin ? 'BlueTag' : 'GrayTag'}
                className={styles['tag']}
                width={'20px'}
                height={'20px'}
              />
              <img
                src={
                    isIndividualAchieved 
                      ? TrophyTag
                    : !isIndividualAchieved && weightOut?.weightOutDate
                      ? RedX
                      : GrayDot
                }
                alt={
                  isIndividualAchieved || isAllWin
                    ? 'Trophy Tag'
                    : !isIndividualAchieved && weightOut?.weightOutDate
                      ? RedX
                      : 'Grey Dot'
                }
                className={styles['dot']}
                width={(isIndividualAchieved || isAllWin) ? '40px' : '20px'}
                height={(isIndividualAchieved || isAllWin) ? '40px' : '20px'}
              />
            </div>
            {/* {isCoachEnrolled || showFiveProgress ? (
              <div
                className={`${subscribe?.length > 0 || isAllSubscribe
                  ? styles['progress-bar-container-icon-line-active']
                  : styles['progress-bar-container-icon-line']
                  }`}
              ></div>
            ) : ( */}
              <div className={`${styles['progress-bar-container-icon-blank']}`}></div>
            {/* )} */}
          </div>
        </div>

        {/* bottom  */}{/* Criteria */}
        <div
          className={`${styles['progress-bar-container']} ${
            // isCoachEnrolled || showFiveProgress
            // ? `${styles['progress-bar-container-five']}`
            // : `${styles['progress-bar-container-four']}`
            `${styles['progress-bar-container-five']}`
            } ${hideProfileImg ? styles['progress-bar-container-center'] : ''}`.trim()}
        >
          <div className={`${styles[purchaseStatus === 1 ? 'progress-bar-container-criteria-achieved' : 'progress-bar-container-criteria-unachieved']}`}>
            {purchaseStatus === 1 ? t('dashboard.my-team.progress-tracker.label.verified') : purchaseStatus === 0 ? t('dashboard.my-team.progress-tracker.label.unverification') : t('dashboard.my-team.progress-tracker.label.pendingVerification')}
          </div>
          <div></div>
          <div></div>
          <div className={`${styles[isIndividualAssessmentAchieved ? 'progress-bar-container-criteria-achieved' : 'progress-bar-container-criteria-unachieved']}`}>
            {isIndividualAssessmentAchieved === 1 ? t('dashboard.my-team.progress-tracker.label.meetCriteria') : isIndividualAssessmentAchieved === 0 ? t('dashboard.my-team.progress-tracker.label.didntMeetCriteria') : ''}
          </div>
          <div className={`${styles[isIndividualAchieved ? 'progress-bar-container-criteria-achieved' : 'progress-bar-container-criteria-unachieved']}`}>
            {isIndividualAchieved === 1 ? t('dashboard.my-team.progress-tracker.label.meetWinningCriteria') : isIndividualAchieved === 0 ? t('dashboard.my-team.progress-tracker.label.didntMeetWinningCriteria') : ''}
          </div>
        </div>
      </div>
      {/* profile progress and status  */}
    </section>
  );

};

export default DetailCardProgress;
export type { DetailCardProgressPropTypes };
